export default __webpack_public_path__ + "static/media/mapCanvas.8b680a46.jsworker";